export const randomString4Leters = (): string => {
  return Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, '')
    .substr(0, 4)
}
export const randomString8Leters = (): string => {
  return [randomString4Leters(), randomString4Leters()].join('')
}
